const {databaseServer} = require("../config/network");

const login = async (username, password) => {
    try {
        return fetch(`${databaseServer}/login`, {
            method: 'POST',
            mode: 'cors',
            body: JSON.stringify({username, password}),
            headers: {'Content-Type': 'application/json'}
        })
            .then(response => response.json())
            .catch(error => console.log(error));
    } catch (error) {
        return { error }
    }
}

// P1-20: `currentPassword` is now required by the server (M-2). Passed as its own
// argument rather than bundled into an object so every existing call site fails to
// compile-read rather than silently sending a request that will be refused.
const updatePassword = async (token, currentPassword, password) => {
    return fetch(`${databaseServer}/update-password`, {
        method: 'POST',
        mode: 'cors',
        body: JSON.stringify({currentPassword, password}),
        headers: {
            'Content-Type': 'application/json',
            'Authorization': token
        }
    })
        .then(response => response.json() )
        .catch(error => console.log(error));
}

module.exports = {
    login,
    updatePassword
}